import { render, staticRenderFns } from "./Members.vue?vue&type=template&id=64b5acca&scoped=true"
import script from "./Members.vue?vue&type=script&lang=js"
export * from "./Members.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/inbox.css?vue&type=style&index=0&id=64b5acca&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b5acca",
  null
  
)

export default component.exports